module.exports = __webpack_public_path__ + "img/雙強聯手.2e829952.jpg";